export const SABLE_SOURCE_URL = 'https://git.sable.moe/SableClient/sable-next';
export const SABLE_DONATE_URL = 'https://opencollective.com/sable';
export const SABLE_SUPPORT_ROOM = '#general:sable.moe';
export const SABLE_UPDATE_MANIFEST_URL =
  'https://git.sable.moe/SableClient/sable-next/releases/download/latest/latest.json';
